// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Data
import { Button, FormHelperText, Grid, Typography } from "@mui/material";

import { useContext, useState } from "react";

import { useNavigate } from "react-router-dom";
import MDLink from "components/MDLink";

import { Divider } from "rsuite";
import { LoginFormContext } from "context/loginFormCtx";
import { TinyTextEditor } from "components/TinyTextEditor";
import { updateEmailTemplate } from "lib/Api/EmailTemplates";
import RichTextEditor from "components/common/RichTextEditor";

function EditEmailTemplateForm({ emailTemplateData }) {
  const { setNotification } = useContext(LoginFormContext);

  const navigate = useNavigate();

  const [textEditorValue, setTextEditorValue] = useState(
    emailTemplateData?.template_content || null
  );
  const [error, setError] = useState();
  const [disabled, setDisabled] = useState(false);

  const handleSubmit = async () => {
    try {
      setDisabled(true);
      if (!textEditorValue) {
        setError("Template Content is required");
        setDisabled(false);
        return;
      }

      const body = {
        template_name: emailTemplateData?.template_name,
        template_content:` <html lang="en">
        <head>
          <meta charset="UTF-8" />
          <meta name="viewport" content="width=device-width,initial-scale=1" />
        </head>
        <body style="font-family: Arial, sans-serif">
          <table cellpadding="0" cellspacing="0" width="100%">
            <tr>
              <td style="padding: 20px">
                <table
                  cellpadding="0"
                  cellspacing="0"
                  width="600"
                  align="center"
                  bgcolor="#ffffff"
                  style="border-radius: 6px; border: 1px solid #e0e0e0"
                >
                  <tr>
                    <td style="padding: 40px 30px">
                      ${textEditorValue}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </body>
      </html>`,
      };
      const response = await updateEmailTemplate(emailTemplateData?.id, body);
      if (response?.status === 200) {
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: "Email Template Updated Successfully!",
          open: true,
        });
        navigate("/email-templates");
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: response?.data?.message || "Something went wrong!",
          open: true,
        });
      }

      setDisabled(false);
    } catch (error) {
      setNotification({
        color: "error",
        icon: "cancel",
        title: "Error",
        content: error?.response?.data?.message || "Something went wrong!",
        open: true,
      });
    }
  };

  return (
    <>
      <Typography variant="h5" fontWeight="medium" sx={{ mb: 3, mt: -3 }}>
        {emailTemplateData?.template_label}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {/* <TinyTextEditor
            setContent={(value) => {
              setTextEditorValue(value);
            }}
            content={emailTemplateData?.template_content}
          /> */}

          <RichTextEditor
            value={textEditorValue}
            onChange={(content) => {
              setTextEditorValue(content);
            }}
            height="400px"
          />
        </Grid>
      </Grid>

      {error ? <FormHelperText sx={{ color: "red" }}>{error}</FormHelperText> : null}

      <Divider />
      <MDBox sx={{ mt: 2 }} display="flex" justifyContent="center" alignItems="center">
        <Button disabled={disabled} sx={{ m: 1 }} onClick={handleSubmit} variant="contained">
          Save
        </Button>
        <MDLink to="/email-templates">
          <Button variant="outlined">Cancel</Button>
        </MDLink>
      </MDBox>
    </>
  );
}

export default EditEmailTemplateForm;
